import React, { useState } from "react";
import "./Formats.css"
import installation_01 from '../../Images/2024/IN_001.webp'
import installation_02 from '../../Images/2024/IN_002.webp'
import installation_03 from '../../Images/2024/IN_003.webp'
import installation_04 from '../../Images/2024/IN_004.webp'
import installation_05 from '../../Images/2024/IN_005.webp'
import installation_06 from '../../Images/2024/IN_006.webp'
import installation_07 from '../../Images/2024/IN_007.webp'
import installation_08 from '../../Images/2024/IN_008.webp'
import installation_09 from '../../Images/2024/IN_009.webp'
import installation_10 from '../../Images/2024/IN_0010.webp'
import installation_11 from '../../Images/2024/IN_0011.webp'

import event_01 from '../../Images/2024/EV_001.webp'
import event_02 from '../../Images/2024/EV_002.webp'
import event_03 from '../../Images/2024/EV_003.webp'
import event_04 from '../../Images/2024/EV_004.webp'
import event_05 from '../../Images/2024/EV_005.webp'
import event_06 from '../../Images/2024/EV_006.webp'
import event_07 from '../../Images/2024/EV_007.webp'
import event_08 from '../../Images/2024/EV_008.webp'
import event_09 from '../../Images/2024/EV_009.webp'
import event_10 from '../../Images/2024/EV_010.webp'
import event_11 from '../../Images/2024/EV_011.webp'
import event_12 from '../../Images/2024/EV_012.webp'
import event_13 from '../../Images/2024/EV_013.webp'
import event_14 from '../../Images/2024/EV_014.webp'
import event_15 from '../../Images/2024/EV_015.webp'
import event_16 from '../../Images/2024/EV_016.webp'
import event_17 from '../../Images/2024/EV_017.webp'
import event_18 from '../../Images/2024/EV_018.webp'
import event_19 from '../../Images/2024/EV_019.webp'
import event_20 from '../../Images/2024/EV_020.webp'
import event_21 from '../../Images/2024/EV_021.webp'
import event_22 from '../../Images/2024/EV_022.webp'
import event_23 from '../../Images/2024/EV_023.webp'
import event_24 from '../../Images/2024/EV_024.webp'
import event_25 from '../../Images/2024/EV_025.webp'
import event_26 from '../../Images/2024/EV_026.webp'
import event_27 from '../../Images/2024/EV_027.webp'
import event_28 from '../../Images/2024/EV_028.webp'
import event_29 from '../../Images/2024/EV_029.webp'
import event_30 from '../../Images/2024/EV_030.webp'
import event_31 from '../../Images/2024/EV_031.webp'
import event_32 from '../../Images/2024/EV_032.webp'
import event_35 from '../../Images/2024/EV_035.webp'
import event_36 from '../../Images/2024/EV_036.webp'
import event_37 from '../../Images/2024/EV_037.webp'
import event_38 from '../../Images/2024/EV_038.webp'
import event_39 from '../../Images/2024/EV_039.webp'
import event_40 from '../../Images/2024/EV_040.webp'
import event_41 from '../../Images/2024/EV_041.webp'
import event_42 from '../../Images/2024/EV_042.webp'

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Masonry from "react-masonry-css";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

const installation_images = [
    { id: 21, original: installation_01, },
    { id: 22, original: installation_02, },
    { id: 23, original: installation_03, },
    { id: 24, original: installation_04, },
    { id: 25, original: installation_05, },
    { id: 26, original: installation_06, },
    { id: 27, original: installation_07, },
    { id: 28, original: installation_08, },
    { id: 29, original: installation_09, },
    { id: 210, original: installation_10, },
    { id: 211, original: installation_11, },
];

const event_images = [
    { id: 11, original: event_01, },
    { id: 12, original: event_02, },
    { id: 13, original: event_03, },
    { id: 14, original: event_04, },
    { id: 15, original: event_05, },
    { id: 16, original: event_06, },
    { id: 17, original: event_07, },
    { id: 18, original: event_08, },
    { id: 19, original: event_09, },
    { id: 110, original: event_10, },
    { id: 111, original: event_11, },
    { id: 112, original: event_12, },
    { id: 113, original: event_13, },
    { id: 114, original: event_14, },
    { id: 115, original: event_15, },
    { id: 116, original: event_16, },
    { id: 117, original: event_17, },
    { id: 118, original: event_18, },
    { id: 119, original: event_19, },
    { id: 120, original: event_20, },
    { id: 121, original: event_21, },
    { id: 122, original: event_22, },
    { id: 123, original: event_23, },
    { id: 124, original: event_24, },
    { id: 125, original: event_25, },
    { id: 126, original: event_26, },
    { id: 127, original: event_27, },
    { id: 128, original: event_28, },
    { id: 129, original: event_29, },
    { id: 130, original: event_30, },
    { id: 131, original: event_31, },
    { id: 132, original: event_32, },
    { id: 135, original: event_35, },
    { id: 136, original: event_36, },
    { id: 137, original: event_37, },
    { id: 138, original: event_38, },
    { id: 139, original: event_39, },
    { id: 140, original: event_40, },
    { id: 141, original: event_41, },
    { id: 142, original: event_42, },
];

function Formats() {

    Fancybox.bind("[data-fancybox]", {});

    const breakpointColumnsObj = {
        default: 3,
        1100: 2,
        700: 2,
    };

    const shuffleArray = (array) => {
        return array
            .map((value) => ({ value, sort: Math.random() }))
            .sort((a, b) => a.sort - b.sort)
            .map(({ value }) => value);
    };

    const allImages = shuffleArray([...installation_images, ...event_images]);

    const [value, setValue] = useState("1");

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };


    return (
        <div className="formate-block">
            <Box sx={{ width: '100%', typography: 'body1' }}>
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList onChange={handleChange} aria-label="lab API tabs example">
                            <Tab label="All" value="1" />
                            <Tab label="Event" value="2" />
                            <Tab label="Installation" value="3" />
                        </TabList>
                    </Box>
                    <TabPanel value="1">
                        <Masonry
                            breakpointCols={breakpointColumnsObj}
                            className="my-masonry-grid"
                            columnClassName="my-masonry-grid_column"
                        >
                            {allImages.map((image) => (
                                <div className="galleryColumn" key={image.id}>
                                    <a href={image.original} data-fancybox data-caption={image.caption}>
                                        <img src={image.original} alt={image.caption} loading="lazy" />
                                    </a>
                                </div>
                            ))}
                        </Masonry>
                    </TabPanel>
                    <TabPanel value="2">
                        <Masonry
                            breakpointCols={breakpointColumnsObj}
                            className="my-masonry-grid"
                            columnClassName="my-masonry-grid_column"
                        >
                            {event_images.map((image) => (
                                <div className="galleryColumn" key={image.id}>
                                    <a href={image.original} data-fancybox data-caption={image.caption}>
                                        <img src={image.original} alt={image.caption} loading="lazy" />
                                    </a>
                                </div>
                            ))}
                        </Masonry>
                    </TabPanel>
                    <TabPanel value="3">
                        <Masonry
                            breakpointCols={breakpointColumnsObj}
                            className="my-masonry-grid"
                            columnClassName="my-masonry-grid_column"
                        >
                            {installation_images.map((image) => (
                                <div className="galleryColumn" key={image.id}>
                                    <a href={image.original} data-fancybox data-caption={image.caption}>
                                        <img src={image.original} alt={image.caption} loading="lazy" />
                                    </a>
                                </div>
                            ))}
                        </Masonry>
                    </TabPanel>
                </TabContext>
            </Box>
        </div>
    )
}

export default Formats